module.exports = __webpack_public_path__ + "img/6-5.f3f2ffa3.svg";